import { render, staticRenderFns } from "./GraficoDiagnostico.vue?vue&type=template&id=6376b82a&scoped=true&"
import script from "./GraficoDiagnostico.vue?vue&type=script&lang=js&"
export * from "./GraficoDiagnostico.vue?vue&type=script&lang=js&"
import style0 from "./GraficoDiagnostico.vue?vue&type=style&index=0&id=6376b82a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6376b82a",
  null
  
)

export default component.exports